const appService = {
  hideNotification(notificationKey: string) {
    return localStorage.setItem(`hide-notification-${notificationKey}`, 'true');
  },
  getNotification(notificationKey: string) {
    return localStorage.getItem(`hide-notification-${notificationKey}`);
  },
};

export default appService;
